'use client';

import { useState, memo } from 'react';
import styles from './BenefitCard.module.css';

interface BenefitCardProps {
  benefit: {
    label: string;
    description: string;
  };
  index: number;
}

export const BenefitCard = memo(function BenefitCard({ benefit, index }: BenefitCardProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={styles.card}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Large Watermark Number - Subtle Background */}
      <div className={styles.watermark}>
        {index + 1}
      </div>

      {/* Top Accent Line */}
      <div className={styles.accentLine} />

      <div className={styles.title}>
        {benefit.label}
      </div>
      <p className={styles.description}>
        {benefit.description}
      </p>
    </div>
  );
});
